<template>
  <div class="product">
    <h1 class="ui header pc">下記のサービスを運営しています</h1>
    <h1 class="ui header smart">下記のサービスを<br>運営しています</h1>
    <h2 class="ui header">公演予約サービス PASSKET</h2>
    <div>
      <p>
        PASSKETは舞台芸術向けの公演予約の管理サービスです。<br>
        無料で使うことができ、利用者からはデザインを評価されています。
      </p>
    </div>
    <div class="product-img">
      <a href="https://passket.net/">
        <img src="../assets/passket.png" alt="passket-top">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2,h3 {
    font-weight: 900;
    color: black;
  }
  p{
    color: black;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
  @media screen and (min-width: 601px) {
    .ui.header.smart{
      display: none;
    }
    .product {
      margin-top: 110px;
    }

    .product-img {
      margin: 50px 10%;
    }

    .product-img img {
      width: 100%;
    }
  }
  @media screen and (max-width: 600px) {
    .ui.header.pc{
      display: none;
    }
    .product {
      margin-top: 110px;
    }

    .product-img {
      margin: 50px 10%;
    }
    .product-img img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue